import { InvoiceIssueTypeDetail, InvoiceIssueTypeDomestic } from '../../../../enums';

export interface IInvoiceSubtypeDom {
    issueType: InvoiceIssueTypeDomestic;
    invoiceErrorType: InvoiceIssueTypeDetail;
    instructionsContained: boolean;
}
